import { createFileRoute } from '@tanstack/react-router';
import { requireFeature } from '@/common/utils/requireFeature';
import { FeatureKey } from '@/common/enums/feature-keys.enum';
import { PermissionGate } from '@/components/PermissionGate';
import { Permission } from '@/common/enums/permissions.enum';
import { PlaybookProcessTypesPage } from '@/features/playbooks/components/PlaybookProcessTypesPage';

export const Route = createFileRoute('/_authenticated/playbooks/config')({
  beforeLoad: async () => {
    await requireFeature(FeatureKey.CLIENT_PLAYBOOKS);
  },
  component: PlaybookConfigRoute,
});

function PlaybookConfigRoute() {
  return (
    <PermissionGate permission={Permission.PLAYBOOKS_CONFIGURE}>
      <PlaybookProcessTypesPage />
    </PermissionGate>
  );
}
